import PropTypes from 'prop-types';
import { useRouter } from "next/router";
import Icon from '@/atoms/Icon/Icon';
import { motion } from 'framer-motion';
import { Fragment, useState } from 'react';

import { analytics, getLanguageSwitcher } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import { localeConfig } from '@/utils/constants';


function LangSwitcher({ style = '' }) {
  const router = useRouter();
  const [showMenu, setShowMenu] = useState(false);
  const locales = localeConfig.locales

  const langSymbols = [
    { symbol: 'en-AU', label: 'English (Australia)' },
    { symbol: 'ko-KR', label: '한국어 (Korea)' },
  ];
  const handleChangeLanguage = (e, { url, name }) => {
    analytics({
      window,
      document,
      detail: getLanguageSwitcher(e, { url, name }),
    });
  };

  const { pathname, query, asPath } = router;
  const activeLocale = localeConfig.locales.find((l) => asPath.startsWith(`/${l}`)) ?? localeConfig.defaultLocale;

  const menuAnimate = {
    enter: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
      display: "flex",
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
      transitionEnd: {
        display: "none",
      },
    },
  };

  // Hide lang switcher if i18n is not enabled (locales will be undefined)
  if (!locales || locales.length === 0) {
    return null;
  }

  return (
    <div className={`aaco-lang-switcher nav-menu__actions__lang relative flex justify-center w-full lg:w-auto ${style}`}>
      <motion.div
        onTap={() => setShowMenu((prev) => !prev)}
        className='relative flex gap-x-1 h-[55px] lg:h-auto justify-center items-center cursor-pointer'
      >
        <Icon
          name="locale"
          height={15}
          width={15}
          className={`text-natural-cream`}
        />
        <div className="text-natural-cream bg-transparent border-none outline-none cursor-pointer aaco-underline aaco-underline--natural-cream">
          {langSymbols.find((l) => l.symbol === activeLocale)?.label}
        </div>
        <Icon
          name="chevron-down"
          width={10}
          height={10}
          className="text-natural-cream mt-[2px] ml-1"
        />
      </motion.div>
      <motion.div
        className="sub-menu absolute top-[55px] lg:top-[32px] left-0 w-full lg:w-[200px] p-[15px] rounded-[8px] bg-white flex flex-col"
        initial="exit"
        animate={showMenu ? "enter" : "exit"}
        variants={menuAnimate}
      >
        {locales.sort().map((item, index) => {
          const displayLabel = langSymbols.find((l) => l.symbol === item)?.label || item;
          return (
            <Fragment key={item}>
              <div
                className="cursor-pointer"
                onClick={(e) => {
                  handleChangeLanguage(e, { name: item, pathname })
                  const pathWithoutLocale = asPath.replace(new RegExp(`^/${activeLocale}`), '') || '/';
                  const newPath = item === localeConfig.defaultLocale ? pathWithoutLocale : `/${item}${pathWithoutLocale}`;
                  window.location.href = newPath;
                }}
              >
                <Text tag="body" style={`text-progressive-blue ${item == activeLocale ? 'font-bold' : ''}`}>
                  {displayLabel}
                </Text>
              </div>
              {index < (locales.length-1) && (
                <hr className="w-full h-[2px] bg-actual-dd-gold my-[12px]"/>
              )}
            </Fragment>
          )
        })}
      </motion.div>
    </div>
  );
}

LangSwitcher.propTypes = {
  style: PropTypes.string,
};

export default LangSwitcher;
